import React, { useEffect, useRef, useState } from "react";
import type { MessageFull } from "../types";
import { apiGet } from "../api";
import { mockMessageFull } from "../mock";
import type { Locale } from "../i18n";
import { t } from "../i18n";

type MsgResp = MessageFull;

export function ReaderPage(props: {
  locale: Locale;
  dataMode: "mock" | "api";
  messageId: string;
  onBack: () => void;
}) {
  const [full, setFull] = useState<MessageFull | null>(null);
  const readerRequestId = useRef(0);

  useEffect(() => {
    readerRequestId.current += 1;
    const currentRequest = readerRequestId.current;
    setFull(null);

    if (props.dataMode === "mock") {
      setFull(mockMessageFull(props.messageId));
      return;
    }

    const controller = new AbortController();
    const signal = controller.signal;

    async function load() {
      try {
        const res = await apiGet<MsgResp>(`/mail/messages/${encodeURIComponent(props.messageId)}`, { signal });
        if (currentRequest !== readerRequestId.current) return;
        if (res.ok) setFull(res.data);
        else setFull(mockMessageFull(props.messageId));
      } catch (err) {
        if (signal.aborted || currentRequest !== readerRequestId.current) return;
        setFull(mockMessageFull(props.messageId));
      }
    }

    void load();
    return () => { controller.abort(); };
  }, [props.dataMode, props.messageId]);

  return (
    <div className="container">
      <div className="card" style={{ padding: 12 }}>
        <div className="row" style={{ justifyContent: "space-between" }}>
          <button className="btn" onClick={props.onBack}>{t(props.locale, "reader.back")}</button>
          <div className="small mono">{props.messageId}</div>
        </div>

        <div style={{ height: 10 }} />

        {full ? (
          <>
            <div className="col" style={{ gap: 6, marginBottom: 12 }}>
              <div className="h1" style={{ fontSize: 18 }}>{full.subject}</div>
              <div className="small">
                <b>{t(props.locale, "reader.from")}:</b> {full.from} &nbsp;
                <b>{t(props.locale, "reader.to")}:</b> {full.to} &nbsp;
                <b>{t(props.locale, "reader.date")}:</b> {new Date(full.dateIso).toLocaleString()}
              </div>
            </div>
            <div className="reader">
              <pre>{full.text}</pre>
            </div>
          </>
        ) : (
          <div className="small">Loading...</div>
        )}
      </div>
    </div>
  );
}
